export const modifierList = [
  'capitalized',
  'editorial-premium',
  'no-outline',
  'primary',
  'primary-on-dark',
  'reverse',
  'secondary',
  'secondary-on-dark',
  'secondary-on-dark-no-outline',
  'sky-it-primary',
  'sky-it-outline',
  'sky-it-no-outline',
  'text',
  'close',
  'on-dark',
];

export const targetList = ['_blank', '_self', '_parent', '_top'];
